/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { Merchant } from "../../../models";
import { CREDIT_CARD_CONSTANTS } from "../../../utils/data.rest.constants";

@Component({
  selector: "app-accepted-credit-cards",
  templateUrl: "./accepted-credit-cards.component.html"
})
export class AcceptedCreditCardsComponent {
  @Input("merchant") merchant!: Merchant;
  CREDIT_CARDS: any = CREDIT_CARD_CONSTANTS.CREDIT_CARDS;
}
